// shared/components/AsyncSelectInput.tsx
import React from 'react';
import AsyncSelect from 'react-select/async';
import { useField, useFormikContext } from 'formik';
import axios from 'axios';

interface AsyncSelectInputProps {
  name: string;
  label: string;
  fetchUrl: string;
  wrapperClassName?: string;
  placeholder?: string;
  isClearable?: boolean;
  isMulti?: boolean;
}

const AsyncSelectInput: React.FC<AsyncSelectInputProps> = ({
  name,
  label,
  fetchUrl,
  wrapperClassName,
  placeholder = 'Seçiniz...',
  isClearable = true,
  isMulti = false,
}) => {
  const [field] = useField(name);
  const { setFieldValue } = useFormikContext<any>();

  const loadOptions = async (inputValue: string) => {
    try {
      const res = await axios.get(fetchUrl, {
        params: { q: inputValue, size: 10 },
      });

      if (!res.data || !Array.isArray(res.data.payload?.content)) {
        console.error('AsyncSelectInput: API response content is not an array');
        return [];
      }

      return res.data.payload.content.map((item: any) => ({
        value: item.id ?? item.value ?? item.code ?? item.plate,
        label:
          item.fullName ||
          item.vehicleType ||
          item.branchName ||
          item.plate ||
          `${item.name ?? ''} ${item.surname ?? ''}`.trim() ||
          item.toString(),
      }));
    } catch (error) {
      console.error('AsyncSelectInput: Failed to fetch options', error);
      return [];
    }
  };

  return (
    <div className={wrapperClassName}>
      <label className="form-label fw-bold">{label}</label>
      <AsyncSelect
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        isMulti={isMulti}
        isClearable={isClearable}
        placeholder={placeholder}
        onChange={(option: any) => {
          if (isMulti) {
            setFieldValue(
              name,
              option ? option.map((o: any) => ({ label: o.label, value: o.value })) : []
            );
          } else {
            setFieldValue(name, option ? { label: option.label, value: option.value } : null);
          }
        }}
        value={
          isMulti
            ? field.value?.map((v: any) => ({ label: v.label, value: v.value })) || []
            : field.value
            ? { label: field.value.label, value: field.value.value }
            : null
        }
      />
    </div>
  );
};

export default AsyncSelectInput;
